/* eslint-disable no-throw-literal */
import {
  GET_HOLDPLACE_LIST,
  GET_HOLDPLACE,
  CREATE_MASTER_HOLDPLACE,
  UPDATE_MASTER_HOLDPLACE,
  DELETE_HOLDPLACE

} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_HOLDPLACE_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/shop_hold_on_places', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CREATE_MASTER_HOLDPLACE] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/shop_hold_on_places', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_HOLDPLACE] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/shop_hold_on_places/${params.id}/edit` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_HOLDPLACE] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/shop_hold_on_places/${params.id}` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_MASTER_HOLDPLACE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/shop_hold_on_places/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/hold-place.js